export default __webpack_public_path__ + "static/media/crispy-vegetables.443a5e7c.webp";